<ul class="nav">
  <li class="nav-item mr-auto" *ngIf="selectedItemIds?.length > 0">
    <a
      id="manage-lists-deployment"
      class="nav-link actions action-button sm-space-x-1"
      (click)="startDeployMode()"
      *ngIf="canDeployLists && selectedItemIds?.length === 1"
      ><i class="cc-icon cc-icon-nav-heirarchy d-inline-block"></i><span>Manage Deployment</span></a
    >
    <a
      id="bulk-deploy-lists"
      class="nav-link actions action-button sm-space-x-1"
      (click)="startDeployMode()"
      *ngIf="canDeployLists && selectedItemIds?.length > 1"
      ><i class="cc-icon cc-icon-nav-heirarchy d-inline-block"></i><span>Deploy</span></a
    >
    <a
      id="bulk-undeploy-lists"
      class="nav-link actions action-button sm-space-x-1"
      (click)="startUndeployMode()"
      *ngIf="canDeployLists && selectedItemIds?.length > 1"
      ><i class="cc-icon cc-icon-block red d-inline-block"></i><span>Undeploy</span></a
    >
    <a
      id="delete-selected-lists"
      class="nav-link actions action-button sm-space-x-1"
      (click)="deleteSelectedItems.emit()"
      ><i class="cc-icon cc-icon-delete red d-inline-block"></i><span>Delete</span></a
    >
  </li>
  <li class="nav-item ml-auto" *ngIf="selectedItemIds?.length === 0">
    <button
      data-cy="new-list"
      class="btn nav-btn-success rounded-0 action-button add-list"
      (click)="createNewItem.emit()"
    >
      Add List
    </button>
  </li>
</ul>
